<template>
  <div class="today-review">
    <div v-if="loaded">
      <div class="top">
        <span class="nickname">{{ nickname }}</span>
        <span class="time">{{ addTime }}日餐卡</span>
      </div>
      <div class="diet-list" v-if="list.length">
        <div class="diet-item" v-for="(item, index) in list" :key="index">
          <FlagComponent
            class="diet-flag"
            :curMeal="item.curMeal"
            :type2="item.type2"
            :pType="item.p_type"
          ></FlagComponent>
          <div class="time">{{ item.p_time }} 点评</div>
          <div class="nickname">{{ item.u_name }}</div>
          <div class="info">{{ item.say }}</div>
          <div class="image-list">
            <div
              :class="{ 'image-item-33': item.content.length > 1 }"
              class="image-item"
              v-for="(imageItem, imageIndex) in item.content"
              :key="imageIndex"
            >
              <van-image
                class="image"
                lazy-load
                radius="10px"
                fit="cover"
                :src="
                  formatImageUrl(
                    imageItem + '?x-oss-process=image/resize,w_600/quality,Q_80'
                  )
                "
                @click.stop="previewImage(index, imageIndex)"
              />
            </div>
          </div>
          <div class="tag-list">
            <div
              class="tag-item"
              v-for="(tagItem, tagIndex) in item.p_label"
              :key="tagIndex"
              >{{ tagItem.label }}</div
            >
          </div>
          <ScoreContent
            :data="item"
            :edit="false"
            :showStar="item.p_type == 7 ? false : true"
          ></ScoreContent>
          <div v-if="item.anomalous">
            <div class="desc-title">异常描述</div>
            <div class="coach-info">{{ item.anomalous || '' }}</div>
          </div>
        </div>
      </div>
      <div class="not-data" v-else>今日暂无点评</div>
    </div>
    <van-loading v-else class="loading" color="#1989fa" />
  </div>
</template>
<script>
import { ImagePreview } from 'vant'
import FlagComponent from '../components/flag-component.vue'
import ScoreContent from '../components/score-content.vue'
export default {
  components: {
    FlagComponent,
    ScoreContent
  },
  data() {
    return {
      uid: '',
      nickname: '',
      addTime: '',
      loaded: false,
      list: []
    }
  },
  created() {
    if (this.$route.query) {
      this.uid = this.$route.query.uid || ''
      this.nickname = this.$route.query.nickname || ''
      this.addTime = this.$route.query.addTime
    }
    this.getData()
  },
  methods: {
    formatImageUrl(imageUrl) {
      if (imageUrl.indexOf('_heic_')) {
        imageUrl = imageUrl + '/format,png'
      }
      return imageUrl
    },
    previewImage(index, imageindex) {
      let images = this.list[index].content.map((item) => {
        return item + '?x-oss-process=image/resize,w_750/quality,Q_100'
      })
      ImagePreview({
        images: images,
        startPosition: imageindex
      })
    },
    getData() {
      let params = {
        uid: this.uid,
        day: this.addTime
      }
      this.$http
        .getApp('member/AppCampCoach/getHistory', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.list = res.data
          } else {
            this.$toast(res.msg)
          }
        })
        .catch(() => {})
        .finally(() => {
          this.loaded = true
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.today-review {
  background-color: #f7f7f7;
  width: 100%;
  min-height: 100vh;
  overflow: hidden;
}

.top {
  margin: 10px 0px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.top .nickname {
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #000;
  margin-right: 7px;
}

.top .time {
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.5);
}

.diet-list {
  overflow: hidden;
  padding: 0px 16px 15px;
  box-sizing: border-box;
}

.diet-item {
  position: relative;
  padding: 14px 20px;
  box-sizing: border-box;
  background-color: #fff;
  border-radius: 5px;
  overflow: hidden;
  margin-bottom: 16px;
}

.diet-item .time {
  text-align: right;
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.5);
  margin-bottom: 10px;
}

.diet-item .nickname {
  font-family: PingFangSC-Medium;
  font-size: 12px;
  color: #000;
  font-weight: 600;
  margin-bottom: 4px;
}

.diet-item .info {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  line-height: 22px;
  color: #000;
  margin-bottom: 10px;
}

.diet-item .diet-flag {
  position: absolute;
  left: 0px;
  top: 0px;
  z-index: 7;
}

.image-list {
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 14px;
}

.image-item {
  width: 100%;
  height: 303px;
  border-radius: 5px;
  overflow: hidden;
  margin-right: 6px;
  margin-bottom: 6px;
}

.image-item-33 {
  width: 97px;
  height: 97px;
}

.image-list .image-item:last-child {
  margin-right: 0px;
}

.image-list .image-item-33:nth-child(3n) {
  margin-right: 0px;
}

.image-item .image {
  width: 100%;
  height: 100%;
}

.tag-list {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 27px;
}

.tag-list .tag-item {
  height: 28px;
  padding: 0px 17px;
  white-space: nowrap;
  line-height: 28px;
  background-color: #fff7e3;
  border-radius: 13px;
  border: solid 1px #ffebd0;
  font-family: PingFangSC-Medium;
  font-size: 12px;
  color: #9e6434;
  margin-right: 8px;
  margin-top: 4px;
  margin-bottom: 4px;
}

.desc-title {
  font-family: PingFangSC-Medium;
  font-size: 14px;
  color: #000;
  font-weight: 600;
  margin-bottom: 4px;
}

.coach-info {
  margin-top: 5px;
  font-size: 12px;
  line-height: 22px;
  color: rgba(0, 0, 0, 0.6);
  overflow: hidden;
}

.not-data {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  text-align: center;
  margin-top: 100px;
  color: rgba(0, 0, 0, 0.5);
}

.loading {
  margin-top: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
